import { HoursRequestRow } from './component/hours-request-row';
import { useDispatch, useSelector } from 'react-redux';
import { UserHeader } from '../../components/user-header';
import { selectUser } from '../../slices/auth';
import { NavLink, Outlet } from 'react-router-dom';
import { useGetOrgByIdQuery } from '../../slices/organizationApiSlice';
import { useGetRequestForOrgQuery } from '../../slices/classroomApiSlice';
import { useEffect, useState } from 'react';
import { SchoolRequestsTitleModel } from './model/school-requests-title.model';
import { SponsorRow } from '../../components/sponsor-row/sponsor-row';
import {
  DisputeStatus,
  GameScreenshotType,
  SocketActions,
  SponsorPlacements,
} from '../../utils/constants';
import DashboardAnnouncement from '../../components/dashboard-announcement';
import { selectAnnouncements, selectChatrooms, selectMatchChats } from '../../slices/inboxSlice';
import {
  useGetAllAnnouncementsQuery,
  useGetAllChatroomsQuery,
  useGetAllFlaggedMatchChatsQuery,
  useGetAllMatchChatsQuery,
} from '../../slices/inboxApiSlice';

function OGMADashboard() {
  const curUser = useSelector(selectUser);
  const dispatch = useDispatch();
  const chatrooms = useSelector(selectChatrooms) ?? [];
  const announcements = useSelector(selectAnnouncements) ?? [];
  const matchChats = useSelector(selectMatchChats) ?? [];
  useGetAllChatroomsQuery({});
  useGetAllFlaggedMatchChatsQuery({});
  useGetAllMatchChatsQuery({});
  useGetAllAnnouncementsQuery({});
  const [reqModel, setReqModel] = useState<SchoolRequestsTitleModel>();
  const { data: organizationData } = useGetOrgByIdQuery({
    id: curUser?.organizations[0]?.id,
    query: '',
  });
  const { data, isLoading, isError } = useGetRequestForOrgQuery('');

  useEffect(() => {
    if (!data) return;
    const currentChatroomIds = data.map((chatroom: any) => chatroom.id);

    dispatch({
      type: SocketActions.ConnectInbox,
      payload: { id: curUser.id, rooms: currentChatroomIds },
    });
  }, [data]);

  const inboxNotifiacationCount =
    announcements?.filter((a: any) =>
      a.Recipients?.some(
        (recipient: any) =>
          recipient.userId === curUser.id &&
          new Date(recipient.lastReadDate).getTime() < new Date(a.send_time).getTime(),
      ),
    ).length +
    chatrooms
      ?.filter((chatroom: any) =>
        chatroom.ChatroomUsers.some((user: any) => user.userId === curUser.id && !user.isArchived),
      )
      ?.flatMap((chatroom: any) => {
        const lastReadDate = chatroom.ChatroomUsers.find(
          (user: any) => user.userId === curUser.id,
        )?.lastReadDate;
        return chatroom.messages.filter(
          (message: any) => new Date(message.time) > new Date(lastReadDate),
        );
      }).length +
    matchChats
      ?.filter((d: any) => {
        return (
          d.disputes.filter(
            (d: any) =>
              d.status === DisputeStatus.NotChecked && d.type === GameScreenshotType.ChatDispute,
          ).length > 0
        );
      })
      ?.reduce((total: number, matchChat: any) => total + matchChat.unreadMatchChats, 0);

  const tabs = [
    { name: 'Match Schedule', link: '' },
    { name: 'Teams', link: './teams' },
    { name: 'Users', link: './users' },
    { name: 'Inbox', link: './inbox' },
  ];

  useEffect(() => {
    if (!data) return;
    setReqModel(new SchoolRequestsTitleModel(data));
  }, [data]);

  return (
    <>
      <div className='flex flex-col p-10 gap-10'>
        <SponsorRow name={SponsorPlacements.Dashboard} />
        <DashboardAnnouncement />
        <div className='flex flex-col gap-10'>
          <div className='flex gap-10 items-center flex-wrap justify-between sticky bg-white top-0'>
            <UserHeader
              name={curUser.firstName}
              image={curUser.image}
              id={curUser.id}
              username={curUser.username}
            />
          </div>
          {/* <StudentDashLiveMatches />
          <StudentDashUpMatches /> */}
          <div>
            <div className='flex'>
              {tabs.map((tab) => {
                return (
                  <NavLink
                    key={tab.link}
                    to={tab.link}
                    end={tab.name === 'Match Schedule'}
                    attr-count={
                      tab.name === 'Inbox' && inboxNotifiacationCount
                        ? inboxNotifiacationCount
                        : null
                    }
                    className={`tabs ${
                      tab === tabs[tabs.length - 1] ? 'last' : ''
                    } notification-show before:!-top-2 before:!-right-2 before:!border-fen-red before:!bg-white before:!text-fen-red`}
                  >
                    <div> {tab.name}</div>
                  </NavLink>
                );
              })}
              <div className='border-b-2 w-full flex justify-end'></div>
            </div>
            <div className='border-2 border-t-0 p-4 border-grey-300'>
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default OGMADashboard;
